import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { STATES } from 'src/app/_appCommon/base/Constants';
import { CustomerAccessDataService } from '../../_dataservices/security/CustomerAccessDataService';

@Component({
  selector: 'app-registro-page',
  templateUrl: './registro-page.component.html',
  styleUrls: ['./registro-page.component.css'],
  providers: [CustomerAccessDataService]
})
export class RegistroPageComponent implements OnInit {

  public currentStep = 1;
  public readonly totalSteps = 6;
  public isSpecialist = true;
  public loading = false;
  public isComplete = false;
  public showOrthodonticsError = false;
  public submitError = '';
  public stepErrors: any = {};
  public States = STATES;
  public nowDate: Date;

  public formData: any = {
    name: '',
    lastName: '',
    secondLastName: '',
    email: '',
    phone: '',
    street: '',
    number: '',
    city: '',
    zipCode: '',
    state: '',
    country: 'México',
    referralId: '',
    professionalLicense: '',
    hasOrthodonticsSpecialty: false,
    clinicName: '',
    contactName: '',
    website: '',
    socialMedia: '',
    institutionName: '',
    coordinatorName: '',
    graduationDate: null,
  };

  constructor(
    private customerAccessDataService: CustomerAccessDataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.nowDate = today;
    this.initTracking();
  }

  get progressPercent(): number {
    return ((this.currentStep - 1) / (this.totalSteps - 1)) * 100;
  }

  public setProfile(isSpecialist: boolean): void {
    this.isSpecialist = isSpecialist;
  }

  public next(): void {
    if (!this.validateCurrentStep()) return;
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.submit();
    }
  }

  public back(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.stepErrors = {};
      this.submitError = '';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  public setGraduationDate(event: any): void {
    const d = new Date(event.value.toString());
    d.setHours(0, 0, 0, 0);
    this.formData.graduationDate = d;
    this.stepErrors.graduationDate = false;
  }

  public goToLogin(): void {
    this.router.navigate(['/']);
  }

  private validateCurrentStep(): boolean {
    this.stepErrors = {};
    this.showOrthodonticsError = false;

    switch (this.currentStep) {
      case 1: return true;
      case 2: return this.validateStep2();
      case 3: return this.validateStep3();
      case 4: return this.validateStep4();
      case 5: return this.validateStep5();
      case 6: return true;
      default: return true;
    }
  }

  private validateStep2(): boolean {
    let valid = true;
    if (!this.formData.name?.trim()) { this.stepErrors.name = true; valid = false; }
    if (!this.formData.lastName?.trim()) { this.stepErrors.lastName = true; valid = false; }
    if (!this.formData.secondLastName?.trim()) { this.stepErrors.secondLastName = true; valid = false; }
    return valid;
  }

  private validateStep3(): boolean {
    let valid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!this.formData.email || !emailRegex.test(this.formData.email)) {
      this.stepErrors.email = true; valid = false;
    }
    if (!this.formData.phone || this.formData.phone.replace(/\D/g, '').length < 10) {
      this.stepErrors.phone = true; valid = false;
    }
    return valid;
  }

  private validateStep4(): boolean {
    let valid = true;
    if (this.isSpecialist) {
      if (!this.formData.hasOrthodonticsSpecialty) { this.showOrthodonticsError = true; valid = false; }
      if (this.formData.hasOrthodonticsSpecialty && !this.formData.professionalLicense?.trim()) {
        this.stepErrors.professionalLicense = true; valid = false;
      }
      if (!this.formData.clinicName?.trim()) { this.stepErrors.clinicName = true; valid = false; }
      if (!this.formData.contactName?.trim()) { this.stepErrors.contactName = true; valid = false; }
    } else {
      if (!this.formData.institutionName?.trim()) { this.stepErrors.institutionName = true; valid = false; }
      if (!this.formData.coordinatorName?.trim()) { this.stepErrors.coordinatorName = true; valid = false; }
      if (!this.formData.graduationDate) { this.stepErrors.graduationDate = true; valid = false; }
    }
    return valid;
  }

  private validateStep5(): boolean {
    let valid = true;
    if (!this.formData.street?.trim()) { this.stepErrors.street = true; valid = false; }
    if (!this.formData.number?.trim()) { this.stepErrors.number = true; valid = false; }
    if (!this.formData.city?.trim()) { this.stepErrors.city = true; valid = false; }
    if (!this.formData.zipCode || this.formData.zipCode.toString().length !== 5) {
      this.stepErrors.zipCode = true; valid = false;
    }
    if (!this.formData.state) { this.stepErrors.state = true; valid = false; }
    return valid;
  }

  private initTracking(): void {
    const fbScript = document.createElement('script');
    fbScript.innerHTML = `
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init','3975839299336329');
      fbq('track','PageView');
    `;
    document.head.appendChild(fbScript);

    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-5RZSLSGYJ1';
    document.head.appendChild(gaScript);

    const gaInitScript = document.createElement('script');
    gaInitScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-5RZSLSGYJ1', {
        linker: { domains: ['aliwell.mx', 'www.aliwell.mx', 'aliwell.cloud'] }
      });
    `;
    document.head.appendChild(gaInitScript);

    this.captureAttributionParams();
  }

  private captureAttributionParams(): void {
    const STORAGE_KEY = 'aliwell_attribution_v1';
    try {
      const existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      const params: Record<string, string> = existing.params || {};
      const trackedKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', '_gl'];
      new URLSearchParams(window.location.search).forEach((value, key) => {
        if (value && trackedKeys.includes(key)) params[key] = value;
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        params,
        landing_path: existing.landing_path || (window.location.pathname + window.location.search)
      }));
    } catch (e) {}
  }

  private getAttributionParams(): Record<string, string> {
    const STORAGE_KEY = 'aliwell_attribution_v1';
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}').params || {};
    } catch (e) {
      return {};
    }
  }

  private trackConversion(): void {
    const p = this.getAttributionParams();
    if ((window as any).fbq) {
      (window as any).fbq('track', 'CompleteRegistration');
    }
    if ((window as any).gtag) {
      (window as any).gtag('event', 'sign_up', {
        method: 'aliwell_registro',
        utm_source: p['utm_source'] || null,
        utm_medium: p['utm_medium'] || null,
        utm_campaign: p['utm_campaign'] || null,
        utm_content: p['utm_content'] || null,
        utm_term: p['utm_term'] || null,
        fbclid: p['fbclid'] || null,
        gclid: p['gclid'] || null,
      });
    }
  }

  private submit(): void {
    this.loading = true;
    this.submitError = '';

    const payload = { ...this.formData };
    payload.loginId = this.formData.email;

    if (!this.isSpecialist) {
      payload.isResident = true;
    } else {
      delete payload.graduationDate;
    }

    this.customerAccessDataService.createAccount(payload).subscribe(
      () => {
        this.isComplete = true;
        this.loading = false;
        this.trackConversion();
      },
      (error: any) => {
        this.loading = false;
        const msg: string = error?.error?.message ?? '';
        if (msg.toLowerCase().includes('correo') || msg.toLowerCase().includes('email') || msg.toLowerCase().includes('registrada')) {
          this.currentStep = 3;
          this.stepErrors = { emailTaken: true };
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.submitError = msg
            ? 'Error: ' + msg
            : 'Ocurrió un error al crear tu cuenta. Intenta de nuevo o escríbenos a hola@aliwell.mx';
        }
      }
    );
  }
}
